export default __webpack_public_path__ + "static/media/real-time-monitoring.a0abf6dd.svg";